import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import Editable from './editable';
import messages from './messages';
import ReadOnly from './read-only';
import { OrderDetailsSectionId } from '../../../fulfillment-plan/order-details-expanded-section-provider';
import ExpanderSection from '../../../tab-section/expander-section/expander-section';
import SectionTitle from '../../../tab-section/title';

import style from './notes.module.less';

const labelMessage = <FormattedMessage {...messages.returnNoteLabel} />;

const Notes = ({ returnFulfillmentId, isEditable }) => {
  return (
    <ExpanderSection
      ariaLabelMessageDescriptor={messages.sectionAriaLabel}
      contentClassName={style['notes-section-content']}
      headerContent={<SectionTitle messageDescriptor={messages.notesSectionTitle} />}
      sectionContent={
        isEditable ? (
          <Editable labelMessage={labelMessage} />
        ) : (
          <ReadOnly labelMessage={labelMessage} returnFulfillmentId={returnFulfillmentId} />
        )
      }
      sectionId={OrderDetailsSectionId.Notes}
    />
  );
};

export default Notes;

Notes.propTypes = {
  returnFulfillmentId: PropTypes.string.isRequired,
  isEditable: PropTypes.bool.isRequired,
};
